import { render, staticRenderFns } from "./CustomTagsAndFieldsRichText.vue?vue&type=template&id=580b5af2&scoped=true&"
import script from "./CustomTagsAndFieldsRichText.vue?vue&type=script&lang=js&"
export * from "./CustomTagsAndFieldsRichText.vue?vue&type=script&lang=js&"
import style0 from "./CustomTagsAndFieldsRichText.vue?vue&type=style&index=0&id=580b5af2&prod&lang=scss&"
import style1 from "./CustomTagsAndFieldsRichText.vue?vue&type=style&index=1&id=580b5af2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580b5af2",
  null
  
)

export default component.exports